export default __webpack_public_path__ + "menu-discount-smop-icon.3354a92c7a7bdc5902944397b563538d.svg";